import { valueDataToStringsWithDelimenters } from "@smartsuite/automation-conditions";

import type {
  ActionOutputData,
  OutputData,
  RecordJobData,
  ValueData,
} from "@smartsuite/automation-engine-api";

/**
 * Helper functions for processing output data
 */
const getRecordListOutputs = (outputData: ActionOutputData): OutputData[] => {
  if (outputData.recordList?.recordList === undefined) {
    return [];
  }
  return outputData.recordList.recordList.records[0]?.outputs || [];
};

export const getOutputValue = (value: ValueData | undefined): string =>
  valueDataToStringsWithDelimenters(value).join("; ");

const isFieldWithSuffix = (input: OutputData): boolean =>
  input.outputId.includes(".");

const findOutputValueAndLabel = (
  outputId: string,
  outputs: OutputData[],
): string | undefined => {
  const output = outputs.find((output) => output.outputId === outputId);
  return output ? getOutputValue(output.value) : undefined;
};

const filterEntireFieldsFromRecordJobData = (
  outputs: OutputData[],
): OutputData[] => {
  return outputs.filter((output) => {
    // Filter the same field
    if (
      outputs.some((output2) => "field-" + output.outputId === output2.outputId)
    ) {
      return false;
    }

    // Filter entire field
    if (!isFieldWithSuffix(output)) {
      const isExistWithSuffix = outputs.some(
        (output2) =>
          output2.outputId.includes(output.outputId) &&
          isFieldWithSuffix(output2),
      );
      return !isExistWithSuffix;
    }
    return true;
  });
};

const RECORD_OUTPUT_IDS = ["title"];

export const getOutputs = (recordJobData: RecordJobData): OutputData[] => {
  if (!recordJobData?.outputData) {
    return [];
  }
  return getRecordListOutputs(recordJobData.outputData);
};

export const getFilteredOutputs = (outputs: OutputData[]): OutputData[] => {
  const withoutEntireFields = filterEntireFieldsFromRecordJobData(outputs);
  return withoutEntireFields.filter((output) =>
    RECORD_OUTPUT_IDS.includes(output.outputId),
  );
};

export const getRecordId = (outputs: OutputData[]): string | undefined => {
  return findOutputValueAndLabel("record_id", outputs);
};
